import React from 'react';

export const organizationContext = React.createContext({
  dispatch: null,
  closeModal: null
});
